export const GP_MODAL_VARIANT_DETECTED_THREADS = 'detectedThreads' as const;

export type GatorProtectDetectedThreadsModalFields = {
  onClose: () => void;
  onPrimary: () => void;
  threatCount: number;
};
